import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { EventsHubService, EDITORMESSAGETYPE, EditorMessage } from "src/app/services/eventshub.service";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { PageObject } from "src/app/models/pageobject";
import { Exam } from "src/app/models/exam";
import { Page } from "src/app/models/page";

@Component({
  selector: "hkt-objectshierarchymenu",
  templateUrl: "./objectshierarchymenu.component.html",
  styleUrls: ["./objectshierarchymenu.component.scss"],
})
export class ObjectsHierarchyMenuComponent implements OnInit, OnDestroy {
  @Input("objects") objects: PageObject[];

  exam: Exam;
  examSubscription: Subscription;
  eventsHubSubscription: Subscription;
  currentPage: Page;
  currentObject: PageObject;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
    private modalDialogService: ModalDialogService,
  ) {
    this.objects = [];
  }

  ngOnInit() {
    this.exam = this.examService.currentExam;
    this.currentPage = this.exam.pages[this.exam.currentPageIndex];
    this.currentObject = null;

    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => {
      this.exam = exam;
      this.currentPage = this.exam.pages[this.exam.currentPageIndex];
      this.currentObject = null;
    });

    this.eventsHubSubscription = this.eventsHubService.onEditorMessage.subscribe(msg => {
      if (msg.type == EDITORMESSAGETYPE.SelectPage) {
        this.currentPage = msg.data;
        this.currentObject = null;
      } else if (msg.type == EDITORMESSAGETYPE.SelectObject) {
        this.currentObject = msg.data;
      }
    });
  }

  ngOnDestroy() {
    this.examSubscription.unsubscribe();
    this.eventsHubSubscription.unsubscribe();
  }

  private sendMessageSelectedObjectChanged() {
    let msg = new EditorMessage();
    msg.type = EDITORMESSAGETYPE.SelectObject;
    msg.data = this.currentObject;
    this.eventsHubService.setEditorMessage(msg);
  }

  onClickObject(obj: PageObject): void {
    this.currentObject = obj;
    this.sendMessageSelectedObjectChanged();
  }

  onDuplicateObject(obj: PageObject): void {
    let newObj = this.currentPage.duplicateAndAddObject(obj, true, this.exam.style);
    newObj.x += 10;
    newObj.y += 10;
    newObj.z++;
    newObj.lock = false;
  }

  onDeleteObject(obj: PageObject): void {
    let index = this.exam.pages[this.exam.currentPageIndex].objects.indexOf(obj);
    if (index >= 0) {
      this.modalDialogService.showConfirmation(Config.APP_NAME, "Are you sure to delete the object?", () => {
        // Yes
        this.exam.pages[this.exam.currentPageIndex].objects.splice(index, 1);
        if (this.currentObject == obj) {
          this.currentObject = null;
          this.sendMessageSelectedObjectChanged();
        }
      });
    }
  }
}
